import {Async, Empty} from 'Core/models/Async';
import {FooterContentDto} from 'Core/models/Footer';
import {makeRand} from 'crypto.js';
import {createAction} from 'Shared/utilities/actionCreator';

export type PortalStaticContentParamType = {
  interactionId: string;
  contentFlag?: string;
  contentStatusCd?: string;
  contentTypeCd?: string;
  loginTypeCd?: string;
  websiteCd?: string;
  contentMetadataId?: string;
};

export enum FooterContentActionType {
  GET_PORTAL_STATIC_CONTENT_BY_PARAMS = 'footerContent/GET_PORTAL_STATIC_CONTENT_BY_PARAMS',
  CHANGE_FOOTER_CONTENT = 'footerContent/CHANGE_FOOTER_CONTENT',
}

export enum FooterLoginTypeCode {
  ALL = 'ALL',
  NON_AUTH = 'LoginNonAuth',
  AUTH = 'LoginAuth',
}

export const DefaultFooterContentParam = {
  CONTENT_STATUS_CD: 'Active',
  CONTENT_TYPE_CD: 'Legal',
  LOGIN_TYPE_CD: FooterLoginTypeCode.ALL,
  WEBSITE_CD: 'BR',
};

export const getNewInteractionId = () => DefaultFooterContentParam.WEBSITE_CD + '-' + makeRand();

export const getDefaultPortalStaticContentParam = (): PortalStaticContentParamType => ({
  interactionId: getNewInteractionId(),
  contentFlag: 'false',
  contentStatusCd: DefaultFooterContentParam.CONTENT_STATUS_CD,
  contentTypeCd: DefaultFooterContentParam.CONTENT_TYPE_CD,
  loginTypeCd: DefaultFooterContentParam.LOGIN_TYPE_CD,
  websiteCd: DefaultFooterContentParam.WEBSITE_CD,
});

export const getFooterContentByParams = (params: PortalStaticContentParamType) =>
  createAction(FooterContentActionType.GET_PORTAL_STATIC_CONTENT_BY_PARAMS, {
    params,
  });

export const changeFooterContent = (footerContent: Async<FooterContentDto>) =>
  createAction(FooterContentActionType.CHANGE_FOOTER_CONTENT, {
    footerContent,
  });

type FooterContentState = {
  footerContent: Async<FooterContentDto>;
};

export const DEFAULT_STATE: FooterContentState = {
  footerContent: new Empty(),
};

type FooterContentAction = ReturnType<typeof getFooterContentByParams> | ReturnType<typeof changeFooterContent>;

export default (state: FooterContentState = DEFAULT_STATE, action: FooterContentAction): FooterContentState => {
  switch (action.type) {
    case FooterContentActionType.CHANGE_FOOTER_CONTENT:
      return {
        ...state,
        footerContent: action.payload.footerContent,
      };
    default:
      return state;
  }
};
